import React from "react";

import './homeBanner.css';
import { Container, Row, Col } from 'react-bootstrap';
import CardCarousel from './cardCarousel';

const HomeBanner = () => {

const imgCDNURL = process.env.REACT_APP_CDN_LINK + "mastermind/homepage/";
const desktopVideoId = "banner-video-desktop";
const mobileVideoId = "banner-video-mobile";
const scrollToSignUpForm = () => {
    const signupForm = document.getElementById('ContactForm');
    if (signupForm) {
        signupForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Define the handlePlayClick function
  const handlePlayClick = (e) => {
    e.preventDefault();
    // Handle the play button click event here, e.g., open a video modal
  };

  return (
    <>
    {window.innerWidth > 991.9 ? (
          <video autoPlay muted loop playsInline id={desktopVideoId} className="banner-deskvideo">
            <source src={`${imgCDNURL}desktop-video.mp4`} type="video/mp4" />
          </video>
        ) : (
          <video autoPlay muted loop playsInline id={mobileVideoId} className="banner-mobvideo">
            <source src={`${imgCDNURL}mobile-video.mp4`} type="video/mp4" />
          </video>
        )}
      <Container>
    <div className="home-banner">
      <h1 className='mastermind-heading'>masterminds</h1>
      <p className='mastermind-subheading'>The Newsletter for Industry Leaders</p>
    </div>
    </Container>
    <Container>
      <Row>
        <Col sm={12} md={12} xl={2} lg={2}>
        <div>
          <img src={imgCDNURL + "angel-image.webp"} alt="angel-image" className="angel-image" lazyload="true"/>
        </div>
        </Col>
        <Col sm={12} md={12} xl={10} lg={10}>
    <CardCarousel />
    </Col>
    </Row>
    </Container>
    </>
  );
};

export default HomeBanner;
